<template>
  <div>
    <mdb-card class="mb-4">
      <mdb-card-header>
        {{title ? title : 'Facebook Feed'}}
      </mdb-card-header>
      <mdb-card-body class="text-center" :id="'fb-container-'+section.id"
                     v-if="section.data.facebookPage">

      </mdb-card-body>
      <mdb-card-footer>
        <div class="small">Provided by Facebook</div>
      </mdb-card-footer>
    </mdb-card>
  </div>
</template>

<script>
import error from '../common/Error'
import {mdbCard, mdbCardBody, mdbCardFooter, mdbCardHeader} from 'mdbvue';

export default {
  name: 'facebookFeedSection',
  components: {
    mdbCard,
    mdbCardHeader,
    mdbCardBody,
    mdbCardFooter,
    error
  },
  props: {
    title: {
      type: String,
      default: "Facebook Feed"
    },
    section: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      debouncer : null
    };
  },
  mounted() {
    this.setupPage()
    window.addEventListener( "resize", _.debounce(this.resizeListener, 500))
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resizeListener)
  },
  methods: {
    resizeListener() {
      this.setupPage()
    },

    setupPage: function () {
      let el = document.getElementById("fb-container-" + this.section.id)
      if (!el) {
        return
      }

      let fbWidth = el.offsetWidth - 50;

      let fbHeight = 800;
      if (fbWidth > 500) fbWidth = 500;
      if (window.innerHeight < 800) fbHeight = 400;
      el.innerHTML = `<iframe src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2F${this.section.data.facebookPage}&show_posts=true&small_header=true&adapt_container_width=true&hide_cover=false&show_facepile=true&width=${fbWidth}&height=${fbHeight}"
                     style="border:none;overflow:hidden"
                     width="${fbWidth}px" height="${fbHeight}px"
                     allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>
      `

    }
  }
};
</script>

